import { useState, useEffect } from "react";
import "./Header.css";
import { useNavigate } from "react-router-dom";
import logo from "../../img/logo.png";
import { useSelector, useDispatch } from "react-redux";
import { getLogoutAction } from "../../redux/actions";
import Cookies from "js-cookie";

//images
import userIcon from "../../img/user_icon.svg";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.authReducer);
  const user = authState?.user;

  const [show, setShow] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      setIsLoggedIn(!!Cookies.get("refresh-token"));
    };

    checkAuth();
    const interval = setInterval(checkAuth, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    Cookies.remove("access-token");
    Cookies.remove("refresh-token");
    Cookies.remove("uuid");
    dispatch(getLogoutAction());
    setIsLoggedIn(false);
    navigate("/login");
  };

  const LogoSection = () => (
    <div
      className="flex items-center cursor-pointer ml-auto lg:ml-28 gap-2"
      role="button"
      tabIndex={0}
      onClick={() => navigate("/")}
      onKeyPress={(e) => e.key === "Enter" && navigate("/")}
    >
      <img src={logo} className="logoWeb" alt="Krishi Mart Logo" />
      <h3 className="text-md font-bold opacity-[.70] text-yellow-500 w-16">
        Krishi Mart
      </h3>
    </div>
  );

  const NavigationLinks = () => (
    <div className="flex-2 w-7/12 mx-auto">
      <ul className="flex mt-4 justify-around items-center">
        <li
          onClick={() => navigate("/")}
          className="text-lg cursor-pointer font-semibold text-[#219653] hover:opacity-90"
        >
          Home
        </li>

        {isLoggedIn && (
          <li
            onClick={() => navigate("/dashboard")}
            className="text-lg cursor-pointer font-semibold text-[#219653] hover:opacity-90"
          >
            My Bookings
          </li>
        )}

        <li
          onClick={() => navigate("/land-leasing")}
          className="text-lg cursor-pointer font-semibold text-[#219653] hover:opacity-90"
        >
          Lease Land
        </li>

        <li
          onClick={() => navigate("/rental-equipment")}
          className="text-lg cursor-pointer font-semibold text-[#219653] hover:opacity-90"
        >
          Rent Equipment
        </li>

        <li
          onClick={() => navigate("/crop")}
          className="text-lg cursor-pointer font-semibold text-[#219653] hover:opacity-90"
        >
          Crop
        </li>

        <li
          onClick={() => navigate("/help")}
          className="text-lg cursor-pointer font-semibold text-[#219653] hover:opacity-90"
        >
          Support
        </li>
      </ul>
    </div>
  );

  const GuestAuthSection = () => (
    <div className="flex items-center">
      <button
        onClick={() => navigate("/login")}
        className="hover:bg-[#219653] bg-white border-2 transition border-[#219653] text-[#219653] hover:text-white font-bold py-1 px-8 rounded mx-2"
      >
        Login
      </button>
      <button
        onClick={() => navigate("/register")}
        className="hover:bg-[#219653] bg-white border-2 transition border-[#219653] text-[#219653] hover:text-white font-bold py-1 px-8 rounded mx-4"
      >
        Sign Up
      </button>
    </div>
  );

  const UserProfileSection = () => (
    <div
      onMouseOver={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      className="my-auto relative"
    >
      <div className="bg-gray-200 rounded-full py-1 px-4 text-gray-700 flex items-center z-40 hover:bg-gray-300 mr-5 cursor-pointer">
        <img
          className="rounded-full w-8 h-8 mr-3"
          src={user?.avatar || userIcon}
          alt="User Avatar"
        />
        <p className="text-lg font-semibold">
          {user?.name ? `Hi, ${user.name}` : "Hi, User"}
        </p>
      </div>
      {show && (
        <div
          onMouseOver={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          className="absolute bg-white rounded-lg z-40 border-2 border-slate-400 p-1"
        >
          <p
            onClick={() => navigate("/update-profile")}
            className="px-5 text-gray-600 py-2 bg-white cursor-pointer border-b border-slate-400 hover:bg-gray-200"
          >
            Profile
          </p>
          <p
            onClick={handleLogout}
            className="px-5 text-gray-600 py-2 bg-white cursor-pointer hover:bg-gray-200"
          >
            Logout
          </p>
        </div>
      )}
    </div>
  );

  return (
    <div className="h-16 inPhone">
      <div className="flex content-center">
        <LogoSection />
        <NavigationLinks />
        {isLoggedIn ? <UserProfileSection /> : <GuestAuthSection />}
      </div>
    </div>
  );
};

export default Header;
